import _ from 'lodash'
import { LAYOUTS } from "../../utils/constants"

const Nav = [
  {
    title: 'dashboard',
    url: LAYOUTS.DASHBOARD
  },
  {
    title: 'programs',
    url: LAYOUTS.PROGRAMS
  },
  {
    title: 'virtual power plants',
    url: LAYOUTS.VPP
  },
  {
    title: 'reports',
    url: LAYOUTS.REPORTS
  },
  {
    title: 'news',
    url: LAYOUTS.NEWS
  }
]

export function getNav(isSuperAdmin, currentUser, isViewOnly) {
  const list = currentUser.gsmAccess === 'true' ? _.cloneDeep(Nav) : []
  if (isSuperAdmin || isViewOnly || (currentUser && currentUser.roles && currentUser.roles.includes('ACCOUNT_ADMIN') && currentUser.apiAccess === 'true')) {
    list.push({
      title: 'developer hub',
      url: LAYOUTS.DEVELOPER
    })
  }
  if (!isViewOnly && isSuperAdmin) {
    list.push({
      title: 'admin',
      url: LAYOUTS.ADMIN
    })
  }

  return list
}